<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> admin_panel_settings </v-icon>
      <span :class="ui.textHeadline"> Admin </span>
      <v-spacer/>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        New user review, company verification and validation, general system administration.
      </div>
    </v-card-text>
    <v-card-actions>
      <v-list-tile class="grow">
        <v-spacer/>
        <v-btn :color="ui.colorWarning" flat dark :to="'/admindash'"
          v-if="this.getUser.basic.admin === true">
          <v-icon left>
            vpn_key
          </v-icon>
          ADMIN
        </v-btn>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  mixins: [apptheme],
  data() {
    return {
      valid: true
    };
  }
};
</script>
